import { RootState, TypedDispatch } from "../../../../../redux/store";
import { connect } from "react-redux";

import {
  getStudentContactById,
  getWebformByInstitute,
  getWebformResponse,
} from "../service/webformSlice";
import { WebformResponseInitialStateDTO } from "../service/types";
import ResponseDetail from "../components/ResponseDetail/ResponseDetail";
import { CreateSourceDTO, NurtureLead } from "../../../Nurture/service/types";
import {
  createSource,
  getLeadListByInstituteAndContact,
  getNurtureLeadBoard,
  nurtureLead,
} from "../../../Nurture/service/nurtureSlice";
import { getBranchList } from "../../../Manage/ManageBranch/service/Branchslice";
import { getBatchList } from "../../../Manage/ManageBatch/service/Batchslice";
import { getAllCourseByInstituteRequest } from "../../../Manage/ManageCourse/service/courseSlice";

interface StateProps extends WebformResponseInitialStateDTO {}

interface DispatchProps {
  GetFormResponse(data: string): void;

  // GetFormResponse(
  //   id: string,
  //   lastEvaluatedKey: string,
  //   limit: number,
  //   lastEvaluatedSortKey: string,
  //   formId: string,
  //   roleInfo: any
  // ): void;
  CreateEnquiry(data: NurtureLead): void;
  GetNurtureLeadBoard(id: string): void;
  GetBranchList(id: string): void;
  GetCourseList(id: string): void;
  GetBatchList(data: any): void;
  GetLeadListByInstituteAndContact(data: any): void;
  CreateSource(data: CreateSourceDTO): void;
  GetStudentContactById(id: string): void;
  GetWebformForInstitute(instituteId: string, webformId: string): void;
}

const mapStateToProps = (state: RootState): StateProps => {
  return {
    getFormResponseSuccess: state.webform.getFormResponseSuccess,
    getFormResponseLoading: state.webform.getFormResponseLoading,
    getFormResponseError: state.webform.getFormResponseError,
    getFormResponseData: state.webform.getFormResponseData,
    getStudentContactByIdSuccess: state.webform.getStudentContactByIdSuccess,
    getStudentContactByIdLoading: state.webform.getStudentContactByIdLoading,
    getStudentContactByIdError: state.webform.getStudentContactByIdError,
    getStudentContactByIdData: state.webform.getStudentContactByIdData,
  };
};

const mapDispatchToProps = (dispatch: TypedDispatch): DispatchProps => {
  return {
    GetFormResponse: (data: string) => {
      dispatch(getWebformResponse(data));
    },
    // GetFormResponse: (
    //   id: string,
    //   lastEvaluatedKey: string,
    //   limit: number,
    //   lastEvaluatedSortKey: string,
    //   formId: string,
    //   roleInfo: any
    // ) => {
    //   dispatch(
    //     getWebformResponse({
    //       id,
    //       lastEvaluatedKey,
    //       limit,
    //       lastEvaluatedSortKey,
    //       formId,
    //       roleInfo,
    //     })
    //   );
    // },
    CreateEnquiry: (data: NurtureLead) => {
      dispatch(nurtureLead(data));
    },
    GetBranchList: (id: string) => {
      dispatch(getBranchList(id));
    },
    GetBatchList: (data: any) => {
      dispatch(getBatchList(data));
    },
    GetCourseList: (id: string) => {
      dispatch(getAllCourseByInstituteRequest(id));
    },
    GetNurtureLeadBoard: (id: string) => {
      dispatch(getNurtureLeadBoard(id));
    },
    GetLeadListByInstituteAndContact: (data: any) => {
      dispatch(getLeadListByInstituteAndContact(data));
    },
    CreateSource: (data: CreateSourceDTO) => {
      dispatch(createSource(data));
    },
    GetStudentContactById: (id: string) => {
      dispatch(getStudentContactById(id));
    },
    GetWebformForInstitute: (instituteId: string, webformId: string) => {
      dispatch(getWebformByInstitute({ instituteId, webformId }));
    },
  };
};
export interface EmailListProps extends StateProps, DispatchProps {}
export const ResponseDetailComponent = connect(
  mapStateToProps,
  mapDispatchToProps
)(ResponseDetail);
